export const DEAL_STATUSES = [
  { value: 'new', label: 'New' },
  { value: 'in_progress', label: 'In Progress' },
  { value: 'won', label: 'Deal Won' },
  { value: 'lost', label: 'Deal Lost' },
];
